import SelectionPopupCountryRow from '../SelectionPopupCountryRow/SelectionPopupCountryRow';
import SelectionSelect from '../SelectionSelect/SelectionSelect';
import { SelectionLevel } from '../../../types/general';
import { SelectionLayoutRowWrapperProps } from '../SelectionLayoutRow/SelectionLayoutRow';

interface ISelectionRowProps extends SelectionLayoutRowWrapperProps {
    showRow?: boolean;
    type: SelectionLevel;
    useFoF?: boolean;
    isSingle?: boolean;
    isMulti?: boolean;
}

const SelectionRow = ({ children, isMulti, ...props }: ISelectionRowProps) => {
    return (
        <SelectionPopupCountryRow {...props}>
            <SelectionSelect />

            {children}
        </SelectionPopupCountryRow>
    );
};
export default SelectionRow;
